import { useLayoutEffect } from "react";

const useForceLightMode = (skip = false) => {
  useLayoutEffect(() => {
    if (skip) return;

    const theme = localStorage.getItem("globalTheme");
    const isDarkModeActive = theme === "dark" || theme === "system";
    isDarkModeActive && document.body.classList.remove("dark");
    document.body.classList.add("light");
  }, [skip]);
};

export default useForceLightMode;
